<mifosx-activate-center *ngIf="actions['Activate']"></mifosx-activate-center>
<mifosx-center-assign-staff *ngIf="actions['Assign Staff']" ></mifosx-center-assign-staff>
<mifosx-close-center *ngIf="actions['Close']"></mifosx-close-center>
<mifosx-center-attendance *ngIf="actions['Attendance']" ></mifosx-center-attendance>
<mifosx-attach-center-meeting *ngIf="actions['Attach Meeting']"></mifosx-attach-center-meeting>
<mifosx-edit-center-meeting *ngIf="actions['Edit Meeting']"></mifosx-edit-center-meeting>
<mifosx-edit-center-meeting-schedule *ngIf="actions['Edit Meeting Schedule']"></mifosx-edit-center-meeting-schedule>
<mifosx-manage-groups *ngIf="actions['Manage Groups']"></mifosx-manage-groups>
<mifosx-staff-assignment-history *ngIf="actions['Staff Assignment History']"></mifosx-staff-assignment-history>
